// Helpers de entrada numérica de formularios — [RGM] 2026-11-04 (Fase B).
//
// Los formularios guardan el TEXTO crudo del input mientras el usuario
// escribe: así se puede BORRAR el campo (antes `Number('')` lo dejaba en 0
// pegado) y escribir decimales ("12." no se corrompe a 12). Al salir del foco
// se normaliza el texto; al enviar, `aNumero` restaura el number que espera el
// backend (el payload no cambia de tipo).
//
// Regla de normalización: quita ceros a la izquierda conservando "0" y la
// parte decimal ("007" → "7", "000" → "0", "0.50" → "0.50"). Un texto que no
// es un decimal simple (coma regional, letras, signos) se deja TAL CUAL: el
// helper no adivina ni reemplaza separadores; la validación del navegador o
// del backend decide. [RGM] 2026-11-04.

/** Decimal simple con punto: entero opcional + decimal opcional. */
const DECIMAL_SIMPLE = /^\d*\.?\d*$/

/**
 * Normaliza el texto de un input numérico al salir del foco.
 * "" → "", "007" → "7", "000" → "0", "0.50" → "0.50".
 * Texto inválido (p. ej. "12,5") → se devuelve intacto.
 */
export const normalizarNumeroTexto = (texto: string): string => {
  if (texto === '') return ''
  if (!DECIMAL_SIMPLE.test(texto)) return texto
  const punto = texto.indexOf('.')
  const entero = punto === -1 ? texto : texto.slice(0, punto)
  const decimales = punto === -1 ? '' : texto.slice(punto)
  // ".5": no hay ceros a la izquierda que quitar (el navegador lo acepta).
  if (entero === '') return texto
  const sinCeros = entero.replace(/^0+/, '')
  return (sinCeros === '' ? '0' : sinCeros) + decimales
}

/**
 * Convierte el texto del input al number del payload ("" → 0).
 * Se usa SOLO al enviar; el estado del formulario sigue siendo string.
 */
export const aNumero = (texto: string): number => Number(normalizarNumeroTexto(texto) || 0)
